import api from './api'

export const authService = {
  login: (credentials: { username: string; password: string }) =>
    api.post('/auth/login', credentials),
  logout: () => api.post('/auth/logout'),
  getSession: () => api.get('/auth/session'),
  changePassword: (payload: { old_password: string; new_password: string }) =>
    api.post('/auth/change-password', payload),
}

export default authService


